import styled from 'styled-components';

export const ScAuthButton = styled.div`
  white-space: nowrap;
  width: 100%;

  button {
    min-width: auto;
  }
`;
